module.exports = __webpack_public_path__ + "img/img16.32e24c6a.svg";